(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    // 
    //

  function pxNetworkTestNetwork(
    $rootScope, EventServiceEvents, $http, toastr, $filter, WorkstationListService, WorkstationListPaging, NetworkModel
    ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=tenant',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/networkProperties/networkTestNetwork/networkTestNetwork.template.html',
      link: function(scope) {

        scope.testing = true;

        var pingState = {
          IDLE: 'IDLE',
          PINGING: 'PENDING',
          TIMED_OUT: 'TIMED_OUT',
          FAILED: 'FAILED',
          SUCCESS: 'Ok',
          DONE: 'COMPLETED'
        };
        
        scope.testReport = [];
        var testTask = {
          command: null,
          startTime: null,
          endTime: null,
          timeElapsed: null,
          state: null,
          taskId: null,
          networks: [],
        };


        (function() {
          if (!scope.context.network) {
            scope.context.network = new NetworkModel(scope.context)
          }
          getWorkstation();
        })();

        function testNetwork () {
          scope.testing = true;
          var newTestTask = angular.copy(testTask);
          scope.context.workstation.testNetwork().then(function(response) {
            newTestTask.command = 'Gateways';
            newTestTask.taskId = response.data._links.self.href;
            newTestTask.startTime = new Date().getTime();
            newTestTask.state = pingState.PINGING;
            scope.testReport.push(newTestTask);
          }).catch(function(error) {
          });
        }

        scope.testNetwork = function () {
          testNetwork();
        }  

        // NOT YET DONE WITH IMPLEMENTING TO NETWORK PROPERTIES
        function getWorkstation () {
          var workstationListPaging = new WorkstationListPaging();
          workstationListPaging.pagingCriteria.networks = scope.context.network.info._links.self.href;
          workstationListPaging.pagingCriteria.active = true;
          workstationListPaging.pagingCriteria.pageSize = 1;
          WorkstationListService.getWorkstationListPaged(workstationListPaging).then(function(response) {
            if (response.list.length > 0) {
              scope.context.workstation = response.list[0];
              testNetwork();
            } else {
              scope.noWorkstationOnline = true;
            }
          }).catch(function(error) {
            console.log(error);
          });
        }

        function sortOutputByNetwork (testTask, output) {

          var resultMap = {
            OK: 1,
            CONNECTION_FAILED: 2,
          } 

          var networks = Array.from(new Set(output.map(
            function (outputRecord) {
              return outputRecord.network
            }))).map(function (outputRecordNetworkId) {
              return { 
                network:outputRecordNetworkId,
                name: scope.context.workstation.info._embedded.networks.filter(function(networkResource) {
                  return outputRecordNetworkId === networkResource._links.self.href
                }).map(function(network) {
                  return network.name;
                }).find(function () {
                  return true;
                }),
                gateways: output.filter(function (i)  { 
                  return i.network === outputRecordNetworkId
                }).sort(function (a, b) {
                  var a1 = resultMap[a.result] || 100;
                  var b1 = resultMap[b.result] || 100;
                  return a1 - b1;
                })
              }
            });

          var testSpecificNetwork = [];
          angular.forEach(networks, function (network) {
            if (scope.context.network.info._links.self.href === network.network) {
              testSpecificNetwork.push(network);
            }
          })

          testTask.networks = testSpecificNetwork;
        };


        function getTestResult (testReport, taskUrl) {
          $http.get(taskUrl).then(function(response) {
            for (var i = 0; i < response.data._embedded.output.length; i++) {
              response.data._embedded.output[i].network = response.data._embedded.output[i]._links['px:network'].href
            }
            sortOutputByNetwork(testReport, response.data._embedded.output);
            deleteTask(taskUrl);
          }).catch(function(error) {
            toastr.error($filter('translate')('ERROR'));
          });
        }

        function deleteTask (taskUrl) {
          $http.delete(taskUrl).then(function(response) {}).catch(function(error) {});
        };
      

        var WORKSTATION_TASK_STATUS_CHANGED_listener = $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.WORKSTATION_TASK_STATUS_CHANGED, function (name, data) {
          if (data.task.indexOf(scope.context.workstation.customProperties.id) > -1 ) {
            for (var i = 0; i < scope.testReport.length; i++) {
              if (scope.testReport[i].taskId === data.task) {
                scope.testing = false;
                scope.testReport[i].endTime = new Date().getTime();
                scope.testReport[i].timeElapsed = scope.testReport[i].endTime - scope.testReport[i].startTime;
                scope.testReport[i].state = pingState[data.newStatus];
                getTestResult(scope.testReport[i], data.task);
              }
            }
          }
        });

        scope.$on('$destroy', function() { 
          WORKSTATION_TASK_STATUS_CHANGED_listener();
        });
        

      }
    };
  }

  pxNetworkTestNetwork.$inject = [
    '$rootScope', 'EventServiceEvents', '$http', 'toastr', '$filter', 'WorkstationListService', 'WorkstationListPaging',
    'NetworkModel'
  ];

  angular
    .module('printix-admin')
    .directive('pxNetworkTestNetwork', pxNetworkTestNetwork);

})();
